import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { PaymentModal } from 'components/payment/PaymentModal'
import {
  AffiliateBenefit,
  CouponBenefit,
  DefaultBenefit,
  InviteBenefit,
  PaymentOrderRequest,
} from 'service/payment'
import useUserStore from 'store/useUserStore'
import useGetPaymentOrderRequests from 'hooks/query/useGetPaymentOrderRequests'
import { SubscriptionPlan, subscriptionType } from 'service/plans'
import { UserType } from 'utils/common'
import { PlanPriceModal } from 'components/payment/PlanPriceModal'
import useGetMakeTotal from 'hooks/query/useGetMakeTotal'
import { InstallExtensionFloating } from 'components/extension/InstallExtensionFloating'
import { Helmet } from 'react-helmet-async'
import { BasicType } from './components/BasicType'
import { ButtonType } from './components/ButtonType'
import { ShortFormType } from './components/ShortFormType'

export const Challenge = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const typeFromQuery = searchParams.get('type') || 'basic' // 기본값 annual

  // 기존 상태 중 type 대신 쿼리 파라미터로 제어
  const [eventType, setEventType] = useState(typeFromQuery)
  const [totalCount, setTotalCount] = useState(0)
  const { data: _totalCount } = useGetMakeTotal()
  const userInfo = useUserStore((state: any) => state.userInfo)
  const [paymentModal, setPaymentModal] = useState<boolean>(false)
  const [type, isType] = useState('annual')
  const [paymentOrderRequest, setPaymentOrderRequest] =
    useState<PaymentOrderRequest>({
      orderId: '',
      productName: '',
      subscriptionType: '',
      price: 0,
      vat: 0,
      id: 0,
    })
  const [affiliateBenefit, setAffiliateBenefit] =
    useState<null | AffiliateBenefit>(null)
  const [defaultBenefit, setDefaultBenefit] = useState<null | DefaultBenefit>(
    null
  )

  const [couponBenefit, setCouponBenefit] = useState<null | CouponBenefit>(null)
  const [isUpgrade, setUpgrade] = useState<boolean>(false)
  const [monthPriceValue, setMonthPriceValue] = useState(0)
  const [inviteBenefit, setInviteBenefit] = useState<null | InviteBenefit>(null)
  const [planIdValue, setPlanId] = useState(0)
  const [isPlan, setIsPlan] = useState<boolean>(false)
  const [isPlanPriceModal, setPlanPiceModal] = useState<boolean>(false)
  const { mutate: getPaymentOrderRequestsMutate } = useGetPaymentOrderRequests()
  const userCheck = () => {
    if (!userInfo) {
      navigate('/sign-up')
      return
    }
  }
  const getPaymentOrderRequests = (planId: number, planPriceId: number) => {
    setPlanId(planId)
    if (!userInfo?.userInfo) {
      navigate('/sign-up')
      return
    }

    // 업그레이드 조건 클릭한 planId와 현재 사용중인 planId가 같을경우에는 상관없지
    if (
      userInfo?.subscriptions?.subscriptionType === subscriptionType.MONTHLY &&
      userInfo?.subscriptions?.planId === planId &&
      type === subscriptionType.ANNUAL
    ) {
      setUpgrade(true)
      setMonthPriceValue(Number(userInfo?.subscriptions?.price))
    } else if (
      // 월결제 달성 후 다시 월결제 조건
      userInfo?.isDone &&
      userInfo?.subscriptions?.planId === planId
    ) {
    } else {
      if (
        !(
          userInfo?.userType === UserType.USER ||
          userInfo?.userType === UserType.체험
        )
      ) {
        setIsPlan(true)
        return
      }
    }

    getPaymentOrderRequestsMutate(
      { planId, planPriceId },
      {
        onSuccess: (data) => {
          setPaymentOrderRequest(data.orderRequest)
          if (data.affiliateBenefit) {
            setAffiliateBenefit(data.affiliateBenefit)
          }
          if (data?.couponBenefit) {
            setCouponBenefit(data.couponBenefit)
          }
          if (data?.inviteBenefit) {
            setInviteBenefit(data.inviteBenefit)
          }
          if (data?.defaultBenefit && type === 'annual') {
            setDefaultBenefit(data.defaultBenefit)
          }
          setPaymentModal(true)
        },
        onError: (e) => {
          console.log(e)
        },
      }
    )
  }
  const moveToPriceGuide = () => {
    navigate('/price-guide')
  }

  const handlePayment = () => {
    userCheck()
    setPlanPiceModal((prev) => !prev)
  }

  const handleCopyClipBoard = async (copyText: string, successText: string) => {
    try {
      await navigator.clipboard.writeText(copyText)
      toast.success(successText, {
        position: 'bottom-center',
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'light',
      })
    } catch (e) {}
  }

  const handleDownloadAll = () => {
    const files = [
      'assets/img/challenge/item1.png',
      'assets/img/challenge/item2.png',
      'assets/img/challenge/item3.png',
    ]
    files.forEach((file, index) => {
      setTimeout(() => {
        const link = document.createElement('a')
        link.href = process.env.PUBLIC_URL + file
        link.download = `fast_cut_challenge_image${index + 1}.jpg`
        link.click()
      }, index * 1000) // 각 파일 다운로드 간 1초 간격
    })
  }

  const handleDownload = (url: string, index: number) => {
    const link = document.createElement('a')
    link.href = process.env.PUBLIC_URL + url
    link.download = `fast_cut_challenge_image${index + 1}.jpg`
    link.click()
  }

  useEffect(() => {
    if (_totalCount !== undefined) {
      setTotalCount(_totalCount)
    }
  }, [_totalCount])

  useEffect(() => {
    setEventType(typeFromQuery)
  }, [typeFromQuery])

  return (
    <>
      <Helmet>
        <title>전액 페이백 챌린지 이벤트</title>
        <meta
          name="description"
          content="수익 두 배의 기회를 누리세요! 선착순 페이백 챌린지"
        />
        <link
          rel="canonical"
          href="https://fastcut.fastseller.shop/challenge"
        />
      </Helmet>
      <div className="md:min-w-[100vw] w-full bg-[#181830] flex justify-center  h-auto pb-10 a">
        <InstallExtensionFloating userInfo={userInfo} />{' '}
        <div className="md:w-[816px] w-[375px] flex flex-col items-center ">
          {typeFromQuery === 'shortForm' && (
            <ShortFormType
              handlePayment={handlePayment}
              handleCopyClipBoard={handleCopyClipBoard}
              handleDownload={handleDownload}
              handleDownloadAll={handleDownloadAll}
              userInfo={userInfo}
              totalCount={totalCount}
              getPaymentOrderRequests={getPaymentOrderRequests}
            />
          )}
          {/*  param type별로 보여주는게 달라짐  */}
          {typeFromQuery === 'button' && (
            <ButtonType
              handlePayment={handlePayment}
              handleCopyClipBoard={handleCopyClipBoard}
              handleDownload={handleDownload}
              handleDownloadAll={handleDownloadAll}
              userInfo={userInfo}
              totalCount={totalCount}
              getPaymentOrderRequests={getPaymentOrderRequests}
            />
          )}
          {typeFromQuery !== 'button' && typeFromQuery !== 'shortForm' && (
            <BasicType
              handlePayment={handlePayment}
              handleCopyClipBoard={handleCopyClipBoard}
              handleDownload={handleDownload}
              handleDownloadAll={handleDownloadAll}
              userInfo={userInfo}
              totalCount={totalCount}
              getPaymentOrderRequests={getPaymentOrderRequests}
            />
          )}
        </div>
        {isPlanPriceModal && (
          <PlanPriceModal
            isPlanPriceModal={isPlanPriceModal}
            setPlanPriceModal={setPlanPiceModal}
            typeFromQuery={typeFromQuery}
            userInfo={userInfo}
          />
        )}
        {paymentModal && (
          <PaymentModal
            setPaymentModal={setPaymentModal}
            paymentOrderRequest={paymentOrderRequest}
            affiliateBenefit={affiliateBenefit}
            inviteBenefit={inviteBenefit}
            affiliatePlan={userInfo?.affiliate?.plan}
            couponBenefit={couponBenefit}
            setCouponBenefitData={setCouponBenefit}
            setAffiliateBenefitData={setAffiliateBenefit}
            userInfo={userInfo?.userInfo}
            planId={planIdValue}
            type={'annual'}
            upgrade={isUpgrade}
            monthPrice={monthPriceValue}
            defaultBenefit={defaultBenefit}
            setDefaultBenefitData={setDefaultBenefit}
          />
        )}
      </div>
    </>
  )
}
